<script>
	// NPM Modules
	import dayjs from 'dayjs';
	import { createEventDispatcher } from 'svelte';
	// Components
	import Pagination from '@/Components/Pagination.svelte';
	import CheckBox from '@/Components/CheckBox.svelte';
	// Stores
	import PromotionStore from '@/Stores/PromotionStore';
	// Services
	import { getUrlParameter, paginationBuilder, setUrlParameter } from '@/Services/Helpers';
	import Icon from '@/Components/Icon.svelte';

	export let promotionType = undefined;
	export let selectedPromotion;

	const dispatch = createEventDispatcher();
	let page = 1;
	let onlyShowActivePromotions = false;

	$: page = parseInt(getUrlParameter('page')) || 1; // Default to page 1!
	$: page && page !== 1 && setUrlParameter('page', page);
	$: links = $PromotionStore.count() && paginationBuilder(PromotionStore.getPagination()); //Used for pagination component
	$: numberOfPages =
		$PromotionStore.count() && PromotionStore.getPagination() && PromotionStore.getPagination().total_pages;
	$: promotions = ($PromotionStore && (promotionType || !promotionType) && filterPromotions()) ?? [];
	$: (onlyShowActivePromotions || !onlyShowActivePromotions) && getPromotions();

	function selectPromotion(promotion) {
		selectedPromotion = promotion;
		dispatch('selected');
	}

	function changePage(e) {
		if (e) {
			page = e.detail.page;
			getPromotions();
			setUrlParameter('page', page);
		}
	}

	export function getPromotions() {
		PromotionStore.getPromotions(promotionType, onlyShowActivePromotions, { perPage: 40, page: page });
	}

	function filterPromotions() {
		if (!$PromotionStore) {
			return [];
		}
		if (promotionType) {
			return $PromotionStore.where('promotion_type.id', promotionType).all();
		}

		return $PromotionStore.all();
	}

	getPromotions();
</script>

<div class="flex flex-col flex-grow">
	<div class="flex flex-row justify-end pt-2 pr-2">
		<CheckBox
			text="Only show active promotions"
			on:change={(e) => (onlyShowActivePromotions = e.target.checked)}
			checked={false}
		/>
	</div>
	{#if numberOfPages > 1}
		<Pagination {links} on:click={changePage} className="my-3" />
	{/if}
	<table class="w-full whitespace-nowrap mt-3">
		<thead>
			<tr class="text-xs text-left text-gray-500 uppercase">
				<th class="px-6 pt-3 pb-2 font-medium text-left">Name</th>
				<th class="px-6 pt-3 pb-2 font-medium text-left">Code</th>
				<th class="px-6 pt-3 pb-2 font-medium text-left">Promotion Type</th>
				<th class="px-6 pt-3 pb-2 font-medium text-left">Active</th>
				<th class="px-6 pt-3 pb-2 font-medium text-left">Published At</th>
				<th class="px-6 pt-3 pb-2 font-medium text-left">Expires At</th>
				<th class="w-px px-6 pt-3 pb-2 font-medium text-right" />
			</tr>
		</thead>
		<tbody class="bg-white">
			{#each promotions as promotion (promotion.id)}
				<tr class="cursor-pointer hover:bg-gray-100 focus-within:bg-gray-100 h-10">
					<td class="px-6 border-t">
						{promotion.name}
					</td>
					<td class="px-6 border-t">
						{promotion.code}
					</td>
					<td class="px-6 border-t">
						{promotion.promotion_type.name}
					</td>
					<td class="px-6 text-center border-t {promotion.active === true ? 'text-green-500' : 'text-gray-500'}">
						<Icon name={promotion.active === true ? 'circle-tick' : 'circle-x'} classes="mx-auto" />
					</td>
					<td class="px-6 border-t">
						{#if promotion.never_expire}
							Never Expires
						{:else}
							{dayjs(promotion.published_at).format('D MMM YYYY, HH:mm')}
						{/if}
					</td>
					<td class="px-6 border-t">
						{#if promotion.never_expire}
							Never Expires
						{:else}
							{dayjs(promotion.expired_at).format('D MMM YYYY, HH:mm')}
						{/if}
					</td>
					<td class="w-px border-t">
						{#if !promotion.is_system}
							<div class="flex flex-shrink justify-end items-center">
								<button
									class="flex flex-grow items-center justify-center btn btn-primary-action"
									on:click={() => selectPromotion(promotion)}
								>
									<span>Open promotion</span>
								</button>
							</div>
						{/if}
					</td>
				</tr>
			{:else}
				<tr>
					<td class="px-6 py-4 text-center border-t" colspan="10">No promotions found.</td>
				</tr>
			{/each}
		</tbody>
	</table>
	{#if numberOfPages > 1}
		<Pagination {links} on:click={changePage} className="my-3" />
	{/if}
</div>
